module.exports = __webpack_public_path__ + "static/media/icon-supplies-nailfile.547706f9.svg";